/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download': {
    width: 16,
    height: 16,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M407 182h-75V15c0-8.29-6.71-15-15-15H195c-8.29 0-15 6.71-15 15v167h-75c-12.68 0-19.69 14.84-11.52 24.61l152 180c5.98 7.18 17.05 7.18 23.03 0l150-180c8.17-9.77 1.17-24.61-11.51-24.61z"/><path pid="1" d="M497 302h-60c-8.29 0-15 6.71-15 15v105H90V317c0-8.29-6.71-15-15-15H15c-8.29 0-15 6.71-15 15v150c0 24.82 20.18 45 45 45h422c24.81 0 45-20.18 45-45V317c0-8.29-6.71-15-15-15z"/>'
  }
})
